import React, { useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import OtpInput from "components/common/OtpInput";
import SubmitButton from "components/common/SubmitButton";

const AuthCodeDialog = ({
  title,
  message,
  confirmText = "Confirm",
  isLoading = false,
  errorMessage = "",
  onConfirm,
  onClose,
}) => {
  const [authCode, setAuthCode] = useState("");

  return (
    <Dialog title={title} onClose={onClose} width={400}>
      <div className="d-flex flex-column align-items-center px-4 py-4">
        {message && <p className="mb-4 text-center text-secondary">{message}</p>}
        <label className="mb-2 fw-bold">Authorisation Code</label>
        <OtpInput value={authCode} onChange={setAuthCode} length={4} />
        {errorMessage && <p className="mt-2 mb-0 text-danger">{errorMessage}</p>}
      </div>
      <DialogActionsBar layout="end">
        <div className="dialog-footer">
          <Button
            type="button"
            onClick={onClose}
            className="common-btn bgBtnSecondary border-0 me-2"
            disabled={isLoading}>
            Cancel
          </Button>
          <SubmitButton
            type="button"
            onClick={() => onConfirm(authCode)}
            className="me-4"
            isLoading={isLoading}
            disabled={authCode.length !== 4}>
            {confirmText}
          </SubmitButton>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default AuthCodeDialog;
